<template>
    <div class="width-full">
        <v-container fluid grid-list-xl class="main-symptom-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                    <button @click="isDialogSearchSymptoms = !isDialogSearchSymptoms"  class="btn-search-symptom-pf-mobile">
                        <v-icon left>search</v-icon>
                    </button>

                    <v-card class="pf-mobile-search-symptoms-list" v-if="isDialogSearchSymptoms">
                            <v-card-title>
                                <div class="main-symptom-search-input-container" :class="{'is-search-mode': isSearchModeActive}">

                                    <v-text-field

                                        :placeholder="text('chatbot.placeholder.searchSymptom')"
                                        ref="searchMainSymptomInput"
                                        type="text"
                                        v-model="searchSymptomInputValue"
                                        :prepend-icon="isSearchModeActive ? 'arrow_back' : 'arrow_back'"
                                        :prepend-icon-cb="toggleSearchMode"
                                        :append-icon="(searchSymptomInputValue && searchSymptomInputValue.length > 0) ? 'clear' : ''"
                                        :append-icon-cb="clearSearchSymptomInputValue"
                                        @focus="activateSearchMode"
                                        solo
                                        flat
                                    ></v-text-field>

                                </div>
                            </v-card-title>

                            <v-card-text>
                                <div class="main-symptom-search-results" v-if="isSearchModeActive
                            && searchSymptomInputValue
                            && searchSymptomInputValue.length > 0">
                                    <div v-if="getSearchSymptomResultList && getSearchSymptomResultList.length > 0 ">

                                        <v-radio-group v-model="selectedSymptom">
                                            <v-list>

                                                <v-list-tile
                                                    v-for="symptom in getSearchSymptomResultList"
                                                    :key="symptom.code"
                                                    @click="handleClickMainSymptomRow(symptom)"
                                                >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title><span class="symptom-name" v-html="markMatchedStringInSymptomName(symptom.name.text, symptom.name.match)"></span></v-list-tile-title>
                                                        <v-list-tile-sub-title v-if="symptom.synonyms && symptom.synonyms.length > 0">
                                        <span class="symptom-synonyms">
                                            <span class="symptom-synonym-item" v-for="synonym in symptom.synonyms" v-html="markMatchedStringInSymptomName(synonym.text, synonym.match)"></span>
                                        </span>
                                                        </v-list-tile-sub-title>
                                                    </v-list-tile-content>
                                                    <v-list-tile-action>
                                                        <v-radio :value="symptom.code"></v-radio>
                                                    </v-list-tile-action>
                                                </v-list-tile>

                                            </v-list>
                                        </v-radio-group>

                                    </div>
                                    <div v-if="getSearchSymptomResultList && getSearchSymptomResultList.length === 0 " class="padding-left-l">
                                        <p class="info-no-results">{{text("pro.chooseMainSymptomPage.search.noResults")}}</p>
                                    </div>
                                </div>
                                <div class="chatbot-search-symptom-dialog" v-else >

                                </div>
                            </v-card-text>

                        </v-card>
                </v-flex>
            </v-layout>

                <v-layout row wrap class="general-info with-alerts pf-standard-mobile pf-mobile-main-symptom">
                    <v-flex lg4 offset-lg4 md8 offset-md2 sm8 offset-sm2 xs12 class="no-padding main-symptom-description">
                        <p class="page-title-pf no-margin-bottom hidden-xs-only">{{text('api.pdf.pageTitle.mainSymptom')}}</p>
                        <standard-stepper  :steps="step"></standard-stepper>
                        <description></description>
                    </v-flex>

                    <v-flex lg4 offset-lg4 md6 offset-md3 sm8 offset-sm2 xs12 class="hidden-xs-only no-padding margin-top-m">


                        <div class="main-symptom-section start-assessment-section-pf">
                            <v-text-field solo clearable
                                          v-model="searchSymptomInputValue"
                                          :label="text('api.search.label') + '...'"
                                          append-icon="search"
                                          class="input-searchSymptom" >
                            </v-text-field>

                            <v-card v-if="searchSymptomInputValue" class="no-chapter-list component-bg-color">

                                <!-- Search RESULTS. -->
                                <v-radio-group v-show="getSearchSymptomResultList.length" v-model="selectedSymptom">

                                    <div v-for="searchResultSymptom in getSearchSymptomResultList" class="margin-bottom-m">
                                        <v-radio :value="searchResultSymptom.code"
                                                 :key="searchResultSymptom.code"

                                                 color="primary"
                                                 class="check-main-symptom">>
                                            <div slot="label" v-html="searchResultSymptom.name.text.replace(searchResultSymptom.name.match, '<b>' + searchResultSymptom.name.match + '</b>')"></div>
                                        </v-radio>
                                        <div v-if="searchResultSymptom.synonyms">
                                    <span v-for="synonym in searchResultSymptom.synonyms" class="synonyms font-size-small">
                                        <span v-html="synonym.text.replace(synonym.match, '<b>' + synonym.match + '</b>' )"></span>
                                    </span>
                                        </div>
                                    </div>

                                </v-radio-group>

                                <!-- No search results. :( -->
                                <div v-show="!getSearchSymptomResultList.length && !getIsLoadingSearchResults">
                                    <span>{{text("api.pro.chooseMainSymptomPage.search.noResults")}}</span>
                                </div>
                                <!-- Pending search request... -->
                                <div v-show="getIsLoadingSearchResults">
                                    <span>{{text("api.pro.chooseMainSymptomPage.search.searching")}}</span>
                                </div>
                            </v-card>

                        <v-expansion-panel class="expansion-panel-chapters">
                            <v-expansion-panel-content v-for="chapter in getChapterTree.chapters"
                                                       :key="chapter.code"
                                                       expand-icon="close"
                                                       >
                                    <div slot="header" class="font-size-medium font-weight-regular header-chapter" @click="expandedPanel">
                                    <span class="icon">
                                        <chapter-icon :image="chapter.imagePath" color="primary"></chapter-icon>
                                    </span>
                                        <span class="name">{{chapter.name}}</span>
                                    </div>

                                <v-card>
                                    <v-card-text>
                                        <div v-if="getChapterTree.hasSubChapters">
                                            <v-radio-group v-model="selectedSymptom">
                                                <v-list>
                                                <v-list-group v-for="subChapter in chapter.subChapters"
                                                              :key="subChapter.code">
                                                    <template slot="activator">
                                                        <v-list-tile >
                                                            <v-list-tile-content>
                                                                <v-list-tile-title v-html="subChapter.name"></v-list-tile-title>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </template>

                                                    <v-list-tile
                                                        v-for="symptom in subChapter.symptoms"
                                                        :key="symptom.code"
                                                        @click="handleClickMainSymptomRow(symptom)"
                                                    >
                                                        <v-list-tile-content>
                                                            <v-list-tile-title><span class="symptom-name">{{symptom.name}}</span></v-list-tile-title>
                                                        </v-list-tile-content>
                                                        <v-list-tile-action>
                                                            <v-radio :value="symptom.code"></v-radio>
                                                        </v-list-tile-action>
                                                    </v-list-tile>

                                                </v-list-group>
                                                </v-list>
                                            </v-radio-group>
                                        </div>


                                        <div v-else>
                                                <v-radio-group v-model="selectedSymptom">
                                                    <v-list class="pf-no-subchapter">
                                                            <v-list-tile
                                                                v-for="symptom in chapter.symptoms"
                                                                :key="symptom.code"
                                                                @click="handleClickMainSymptomRow(symptom)"
                                                                class="answer-item"
                                                            >
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title><span class="symptom-name">{{symptom.name}}</span></v-list-tile-title>
                                                                </v-list-tile-content>
                                                                <v-list-tile-action>
                                                                    <v-radio :value="symptom.code"></v-radio>
                                                                </v-list-tile-action>
                                                            </v-list-tile>

                                                    </v-list>
                                                </v-radio-group>

                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>

                        </v-expansion-panel>

                        <div class="pf-footer hidden-xs-only pf-main-symptom-footer">
                            <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn">
                                <v-icon>keyboard_arrow_left</v-icon>
                                {{ text('api.button.back') }}
                            </v-btn>
                            <v-btn flat color="primary" @click="goToNextPage" :disabled="!selectedSymptom" class="footer-btn footer-btn-next">
                                {{ text('api.button.next') }}
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                        </div>

                        </div>

                    </v-flex>

                    <v-flex class="pf-chapters-mobile">
                        <!-- CHAPTERS -->
                        <div v-if="getChapterTree" class="chapter-list-container hidden-sm-and-up ">

                            <div class="chapter-list">
                                <v-container fluid grid-list-xl>
                                    <v-layout row wrap>
                                        <v-flex xs6 sm4 v-for="chapter in getChapterTree.chapters"
                                                :key="chapter.code"
                                                class="chapter-item"
                                                @click="openChapter(chapter, $event)">

                                            <div  class="chapter-item-content">
                                                <chapter-icon :image="chapter.imagePath"></chapter-icon>
                                                <button>{{chapter.name}}</button>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </div>

                        </div>

                        <!-- SUBCHAPTERS / SYMPTOMS DIALOG -->
                            <v-card  v-if="activeChapter"
                                    class="popup-subchapters-symptoms-wrapper mobile hidden-sm-and-up">


                                <v-card-title class="headline">
                                    <chapter-icon :image="chapterImagePath" color="primary"></chapter-icon>
                                    <span class="popup-subchapters-symptoms-title">{{activeChapter.name}}</span>
                                    <v-spacer></v-spacer>
                                    <button  @click="closeChapter()" class="float-right"><v-icon class="font-weight-light">clear</v-icon></button>
                                </v-card-title>

                                <v-card-text class="content">
                                    <v-flex xs12>
                                        <div v-if="getChapterTree.hasSubChapters">

                                            <v-radio-group v-model="selectedSymptom">
                                                <v-list>
                                                    <v-list-group v-for="subchapter in activeChapter.subChapters"
                                                                  :key="subchapter.code"
                                                                  v-model="subchapter.active">
                                                        <template slot="activator">
                                                            <v-list-tile>
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title><span class="subchapter-name">{{subchapter.name}}</span></v-list-tile-title>
                                                                </v-list-tile-content>
                                                            </v-list-tile>
                                                        </template>

                                                        <v-list-tile
                                                            v-for="symptom in subchapter.symptoms"
                                                            :key="symptom.code"
                                                            @click="handleClickMainSymptomRow(symptom)"
                                                        >
                                                            <v-list-tile-content>
                                                                <v-list-tile-title><span class="symptom-name">{{symptom.name}}</span></v-list-tile-title>
                                                            </v-list-tile-content>
                                                            <v-list-tile-action>
                                                                <v-radio  class="radio-btn" :value="symptom.code"></v-radio>
                                                            </v-list-tile-action>
                                                        </v-list-tile>

                                                    </v-list-group>
                                                </v-list>
                                            </v-radio-group>

                                        </div>

                                        <div v-else>
                                            <v-radio-group v-model="selectedSymptomNoChapter">
                                                <v-list-tile
                                                    v-for="symptom in activeChapter.symptoms"
                                                    :key="symptom.code"
                                                    @click="handleClickMainSymptomRow(symptom)"
                                                    class="list-no-subchapters"

                                                >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title><span class="symptom-name">{{symptom.name}}</span></v-list-tile-title>
                                                    </v-list-tile-content>
                                                    <v-list-tile-action>
                                                        <v-radio  class="radio-btn" :value="symptom.code"></v-radio>
                                                    </v-list-tile-action>
                                                </v-list-tile>
                                            </v-radio-group>
                                        </div>


                                    </v-flex>
                                </v-card-text>
                            </v-card>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex>
                        <div class="footer pf-standard-mobile hidden-sm-and-up">
                                <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn back-pf">
                                    <v-icon>keyboard_arrow_left</v-icon>
                                    {{ text('api.button.back') }}
                                </v-btn>

                                <mobile-stepper :steps="step"></mobile-stepper>

                                <v-btn flat color="primary" @click="goToNextPage"  :disabled="!selectedSymptom" class="footer-btn footer-btn-next next-pf">
                                    {{ text('api.button.next') }}
                                    <v-icon>keyboard_arrow_right</v-icon>
                                </v-btn>

                        </div>
                    </v-flex>
                </v-layout>

        </v-container>


    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import HeaderBar from "../../shared/HeaderBar";
    import TopBar from '../../../../common/components/shared/TopBar';
    import AssessmentAlerts from "../../../../common/components/shared/AssessmentAlerts";
    import PatientInfo from "../../../../common/components/shared/PatientInfo";
    import ChapterIcon from "../../../../professional/components/choose-main-symptom/ChapterIcon";
    import axios from 'axios/dist/axios';
    import Description from '../../shared/Description';
    import StandardStepper from '../../shared/StandardStepper';
    import MobileStepper from '../../shared/MobileStepper';

    export default {
        name: 'MainSymptomPage',
        components: {
            HeaderBar,
            TopBar,
            AssessmentAlerts,
            PatientInfo,
            ChapterIcon,
            Description,
            StandardStepper,
            MobileStepper
        },
        data() {
            return {
                chooseSymptomChapter: [],
                tempPatientComment: "",
                showComment: false,
                selectedSymptom: null,
                radioGroup: '',
                step: 3,
                isChapterOpen: false,
                activeChapter: null,
                isDialogSearchSymptoms: false,
                isSearchModeActive: false,
            }
        },

        beforeCreate() {
            if (typeof this.$route.query.referral === "undefined" || this.$route.query.referral !== "testsTreeNode") {
                this.$store.commit('ChooseMainSymptomStore/resetStore');
                this.$store.commit('AssessmentAlertsStore/resetStore');
            }
        },

        created() {
            // If the url has param ?referral=testsTreeNode, that means that we are coming from tests tree,
            // so data for this page should be already loaded and must be kept and used.
            // Otherwise, (re)load data now.
            if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "testsTreeNode") {
                this.$router.replace({'referral': null});
            }
            else {
                this.$store.dispatch("PfMainSymptomStore/loadChapterTree");
            }


        },
        computed: {
            ...mapGetters({
                isMainSymptomSelected: 'ChooseMainSymptomStore/isMainSymptomSelected',
                getChapterTree: 'PfMainSymptomStore/getChapterTree',
                patientProfileData: 'AssessmentStartStore/getPatientProfileData',
                getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList',
                getActiveChapter: 'PfMainSymptomStoregetActiveChapter',
                getActiveChapterCode: 'PfMainSymptomStore/getActiveChapterCode',
                getSearchSymptomResultList: 'ChooseMainSymptomStore/getSearchSymptomResultList',
                getIsLoadingSearchResults: 'ChooseMainSymptomStore/getIsLoadingSearchResults',
                getSearchSymptomInputValue: 'ChooseMainSymptomStore/getSearchSymptomInputValue',
                getSelectedMainSymptomCode: 'PfMainSymptomStore/getSelectedMainSymptomCode'

            }),
            symptomId () {
                return this.$store.state["ChooseMainSymptomStore"].selectedMainSymptomId;
            },
            searchSymptomInputValue: {
                get: function(){
                    return this.$store.state["ChooseMainSymptomStore"].searchSymptomInputValue;
                },
                set: function(newValue){
                    this.$store.commit('ChooseMainSymptomStore/setSearchSymptomInputValue', newValue);
                    this.$store.commit('ChooseMainSymptomStore/setActiveChapter', null); // Unselect chapter.
                    this.$store.dispatch('ChooseMainSymptomStore/submitSearchSymptom', newValue);
                    this.isDialogSearchSymptoms = true;
                }

            }
        },

        methods: {

            setTemporaryPatientCommentValue() {
                this.tempPatientComment = this.patientProfileData.comment;
            },

            isPatientCommentChanged() {
                return this.tempPatientComment !== this.patientProfileData.comment;
            },

            savePatientComment: function() {
                if (this.isPatientCommentChanged()) {
                    this.$store.dispatch("AssessmentStartStore/submitPatientProfileComment", {
                        fieldName: "COMMENT",
                        fieldValue: this.patientProfileData.comment
                    });
                }
                this.showComment = false;
            },


            goToPreviousPage() {
                this.$router.push('/pathfinder/general-questions');
            },

            goToNextPage() {
                if (this.selectedSymptom) {
                    console.log(this.selectedSymptom);
                    // Go to Choose Main Symptom page.
                    this.$store.commit('PfMainSymptomStore/setSelectedMainSymptomCode', {symptomCode: this.selectedSymptom});
                    axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/chooseMainSymptom', {symptomCode: this.selectedSymptom});
                    this.closeChapter();
                    this.chooseMainSymptom(this.selectedSymptom);
                    let that = this;
                    setTimeout(function() {
                        that.$router.push('/pathfinder/related-symptoms');
                    }, 100)


                }
            },
            gotoScoringPage(){
                let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment');
                promiseEvaluateAssessment.then(() => {
                    this.$store.commit('ScoringStore/clearTestTreeData');
                    this.$router.push('/scoring');
                });
                promiseEvaluateAssessment.catch(() => {
                    // @TODO This alert with static text is just a quick solution until we decide what to display to the user when the request wasn't successfully done. Need to replace alert() with something else and the text must use translation mechanism.
                    alert("Couldn't evaluate assessment. Please try again.");
                });
            },
            selectChapter (chapterObj) {
               console.log(chapterObj)
            },
            handleClickMainSymptomRow (clickedSymptom) {
                this.selectedSymptom = clickedSymptom.code;
                this.$store.commit('PfMainSymptomStore/setSelectedMainSymptomCode', this.selectedSymptom);
                this.$store.commit('PfMainSymptomStore/setSelectedMainSymptomCode', {symptomCode: this.selectedSymptom})

            },
            handleSymptomSelection (newSelectedSymptomCode) {
                this.$store.commit('ChooseMainSymptomStore/setSelectedMainSymptomCode', newSelectedSymptomCode);
            },
            expandedPanel(e) {
                let activePanel =  e.currentTarget;
                activePanel.classList.toggle('validate');

                let checkSelected = document.getElementsByClassName('validate');
                let selectedSymptom = Array.from(checkSelected);

                let allLi = document.getElementsByClassName('expansion-panel__container');
                let divsToHide = Array.from(allLi);

                let activeLi = document.getElementsByClassName('expansion-panel__container--active');
                let showActive = Array.from(activeLi);

                if(selectedSymptom.length > 0 && showActive.length < 1) {
                    setTimeout(function () {
                        for (let i = 0; i < divsToHide.length; i++) {

                            if (divsToHide[i].classList.contains('expansion-panel__container--active')) {
                                divsToHide[i].setAttribute('style', 'visibility: visible !important');
                                divsToHide[i].setAttribute('style', 'display: block !important');
                            } else {
                                divsToHide[i].style.visibility = "hidden";
                                divsToHide[i].style.display = "none";
                            }
                        }

                        let activeLi = document.getElementsByClassName('expansion-panel__container--active')
                        let divsToShow = Array.from(activeLi);

                        if(divsToShow.length > 0) {
                            divsToShow[0].setAttribute('style', 'visibility: visible !important');
                            divsToShow[0].setAttribute('style', 'display: block !important');
                        }

                    }, 100);
                } else {
                    setTimeout(function () {
                    for (let i = 0; i < divsToHide.length; i++) {
                            divsToHide[i].setAttribute('style', 'visibility: visible !important');
                            divsToHide[i].setAttribute('style', 'display: block !important');

                 }
                    }, 100);
                }
            },
            chooseMainSymptom (symptom) {
                this.closeChapter();

                if (this.getSearchSymptomInputValue.length > 0) {
                    this.$store.commit('ChooseMainSymptomStore/clearSearchSymptomInputValue');
                }
                if (this.getSearchSymptomInputValue.length > 0 || this.getSearchSymptomResultList.length > 0) {
                    this.$store.commit('ChooseMainSymptomStore/clearSearchSymptomResultList');
                }

            },
            confirmSelectedMainSymptom () {
                this.chooseMainSymptom(this.selectedSymptom);
            },
            confirmSelectedMainSymptomNoChapter(){
                this.chooseMainSymptom(this.selectedSymptomNoChapter);
            },

            openChapter(chapter, event){
                console.log("openChapter(). chapter:", chapter);
                this.activeChapter = chapter;
                this.isChapterOpen = true;
                console.log(this);
                let ex = '';
                let ey = '';
                let style =  document.documentElement.style;
                let clickElement = document.getElementsByClassName('chapter-item')[0];
                let elemWidth = clickElement.offsetWidth;
                let elemLeft = clickElement.offsetLeft;
                if(elemWidth !== window.screen.width){
                    ex= event.clientX - elemLeft + 'px';
                    ey=event.clientY - clickElement.offsetTop+ 'px';
                } else {
                    ex=event.clientX + 'px';
                    ey=event.clientY + 'px';
                }
                style.setProperty('--x', ex);
                style.setProperty('--y', ey);
                setTimeout(function(){
                    let activeChapterMobile = document.getElementsByClassName('popup-subchapters-symptoms-wrapper');
                    console.log(activeChapterMobile.length);
                    console.log(activeChapterMobile[0])
                    activeChapterMobile[0].classList.add('expandChapter');
                },100)


            },
            closeChapter() {
                this.activeChapter = null;
            },
            activateSearchMode() {
                this.isSearchModeActive = true;
            },
            deactivateSearchMode() {
                if (this.getSearchSymptomInputValue && this.getSearchSymptomInputValue.length > 0) {
                    this.$store.commit('ChooseMainSymptomStore/clearSearchSymptomInputValue');

                }
                if (this.getSearchSymptomResultList && this.getSearchSymptomResultList.length > 0) {
                    this.$store.commit('ChooseMainSymptomStore/clearSearchSymptomResultList');
                }
                this.isSearchModeActive = false;
                this.isDialogSearchSymptoms= false;
            },
            toggleSearchMode() {
                this.deactivateSearchMode();

            },
            clearSearchSymptomInputValue() {
                if (this.getSearchSymptomInputValue && this.getSearchSymptomInputValue.length > 0) {
                    this.$store.commit('ChooseMainSymptomStore/clearSearchSymptomInputValue');
                }
            },
            markMatchedStringInSymptomName(symptomName, matchedString) {
                if (!symptomName) {
                    return "";
                }
                return symptomName.replace(matchedString, '<span class="match"><b>'+matchedString+'</b></span>');
            }
        },
        watch:{
            activeChapter(newVal, oldVal){
                if(newVal) {
                    this.chapterImagePath = newVal.imagePath;
                }
            }
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .expansion-panel__header {
        padding-bottom: 20px;
        padding-top: 20px;
    }


    .alerts-top {
        display: inline-flex;
    }

    .topbar-patient-info-content {
        position: fixed;
        right: 145px !important;
    }

    .header-chapter {
        display: inline-block;

        .name {
            position: relative;
            top: 1px;
            margin-left: 40px;

        }
    }


    .scrolling-content {
        overflow: hidden !important;
    }

    .footer-btn-next {
        float: right !important;
    }

    .scrolling-content.path {
        top: 110px !important;
    }


    .start-assessment-section-pf .expansion-panel-chapters .header__icon{
        position: absolute;
        float: right;
        right: 15px;
    }

    .main-symptom-section.start-assessment-section-pf .expansion-panel__container .card .card__text .input-group ul.list .list__group:last-of-type {
        border-bottom: 1px solid $color-element-outline;
    }

    .main-symptom-section {
        padding: 5px 28px 0px !important;
        background-color: $color-block-background;
        // padding-bottom: 80px !important;
    }


    @media only screen and (max-width: 600px) {
        .pf-standard-mobile.pf-mobile-main-symptom {
            margin-top: 0 !important;
            background-color: $color-gray-lightest;
        }

        .footer-btn-next.next-pf {
            position: absolute;
            right: 0;
            bottom: 4px;
        }

        .footer-btn.back-pf {
            position: absolute;
            top: 4px;
        }

        .pf-chapters-mobile {
            height: calc(100vh - 220px) !important;
            .chapter-list {
                .container {
                    overflow-y: auto;
                    height: calc(100vh - 243px);
                }
            }
        }

        .pf-mobile-main-symptom {

            background-color: $color-block-background;

            .main-symptom-description {
                background-color: $color-gray-lightest;
            }
        }

        .popup-subchapters-symptoms-wrapper.mobile.expandChapter.card {
            position: absolute !important;
            top: 12px !important;
            width: 95%;
            -webkit-animation: fadein 0.5s ease-out; /* Safari, Chrome and Opera > 12.1 */
            -moz-animation: fadein 0.5s ease-out; /* Firefox < 16 */
            -ms-animation: fadein 0.5s ease-out; /* Internet Explorer */
            -o-animation: fadein 0.5s ease-out; /* Opera < 12.1 */
            animation: fadein 0.5s ease-out;
            display: block;
            height: calc(100vh - 240px) !important;

        }


        @-moz-keyframes fadein
        {
            from {opacity: 0; height:0}
            to { opacity: 1;  height: calc(100vh - 240px)}
        }

        @-webkit-keyframes fadein
        {
            from {opacity: 0; height:0}
            to { opacity: 1;  height: calc(100vh - 240px)}
        }


        @-ms-keyframes fadein /* IE10 */
        {
            from {opacity: 0; height:0}
            to { opacity: 1;  height: calc(100vh - 240px)}

        }

        @keyframes fadein
        {
            from {opacity: 0; height:0}
            to { opacity: 1;  height: calc(100vh - 240px)}
        }

        .pf-mobile-main-symptom {
            .popup-subchapters-symptoms-title {
                // SMASSDEV - 1119
                font-size: $font-size-medium;
                // word-spacing: $word-spacing-medium;
                // line-height: $line-height-medium;
                // letter-spacing: $letter-spacing-medium;
                margin-left: 10px !important;
            }
        }

        .btn-search-symptom-pf-mobile {
            position: absolute;
            right: 15px;
            z-index: 9999;
            top: 30px;
        }

        .pf-mobile-search-symptoms-list {
            height: calc(100vh - 60px) !important;
            position: absolute;
            z-index: 99999;
            top: 0;
            left: 0;
            width: 100%;
            padding: 0;

            .main-symptom-search-input-container {
                width: 100%;
            }

            .main-symptom-search-results {
                height: calc(100vh - 160px) !important;
                overflow: auto;
            }
        }

        .pf-standard-mobile {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;

                &.btn--disabled {
                    color: rgba(0,0,0,.26) !important;
                }
            }
        }

        .pf-chapters-mobile {
            position: relative;

            .chapter-list-container {
                background-color: $color-block-background;
            }
        }

    }

    .pf-standard-mobile.pf-mobile-main-symptom {
        margin-top: 30px !important;
    }

    .start-assessment-section-pf .pf-footer.pf-main-symptom-footer {
        bottom: 0 !important;
        padding: 5px 0 !important;
        position: relative !important;
    }

    .main-symptom-section {
        height: calc(100vh - 360px) !important;

        .input-searchSymptom {
            height: 50px !important;
        }

        .expansion-panel-chapters{
            height: calc(100% - 125px) !important;
            display: block;
            margin-top: 20px;
        }

        .pf-footer {
            height: 60px !important;

            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;

                &.btn--disabled {
                    color: rgba(164,58,69,.36) !important;

                    .icon {
                        color: rgba(164,58,69,.36) !important;
                    }
                }
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/pathfinder/components/standard-forms/main-symptom/MainSymptomPage.vue